import useDictionary from "redux/dictionary/useDictionary";

export const LanguageField = ({ value }: { value: string }) => {
  const [languageDictionary] = useDictionary("language-ISO-639-1");
  let lIds: string[] = [];
  try {
    lIds = JSON.parse(value);
  } catch {
    lIds = [value];
  }

  const languageNames = lIds.map((lId) => {
    const language = languageDictionary.find(
      (language) => language?.id === lId
    );
    return language?.title ?? lId;
  });
  return <span>{languageNames.join(", ")}</span>;
};
